//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  -- List books ----------------
export const rubricInit = (returnedPayload) => ({ type: ActionTypes.rubric.getRubric, payload: returnedPayload });
export const createRubric = (returnedPayload) => ({ type: ActionTypes.rubric.createRubric, payload: returnedPayload });
export const rubricDelete = (returnedPayload) => ({type: ActionTypes.rubric.rubricDelete, payload: returnedPayload })
export const rubricEdit = (returnedPayload) => ({type: ActionTypes.rubric.rubricEdit, payload: returnedPayload })

export const rubricFail = () => ({ type: ActionTypes.rubric.rubricFail });
//  -- List All books ----------------
